// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3VicP","boxTitle":"Qualiphy_boxTitle__3Gcz5","box":"Qualiphy_box__21Xfn","toggleWrap":"Qualiphy_toggleWrap__2JeC-"};